import React, { useState, useRef, useEffect } from 'react';
import { Eye, EyeOff, ChevronsUp, ChevronsDown, ChevronRight, ChevronDown, FolderOpen, Folder, Package, Building, Plus, Search, Mail, Phone, MapPin, Calendar, Edit2, Save, X, Send, Clock, Tag, MessageSquare, LayoutDashboard } from 'lucide-react';
import { treeDataService } from '../services/treeDataService';
import ProfileDropdown from './ProfileDropdown';
import { getProfile, getUsername } from "../utils/formatters";
import api from '../services/api';

const TreeArchitectureApp = ({ user, onLogout }) => {
  const [treeData, setTreeData] = useState([]);
  const [activeProfile, setActiveProfile] = useState("");

  // Load data from API on component mount
  useEffect(() => {
    console.log("loadTreeData=" + activeProfile)
    loadTreeData();
  }, [activeProfile]);

  const loadTreeData = async () => {
    try {
      const data = await treeDataService.getAllGroups();
      setTreeData(data);
    } catch (error) {
      console.error('Error loading tree data:', error);
      // Show error message to user
      alert('Failed to load data from server. Please check if the API is running.');
    }
  };


  const [treeDataXX, setTreeDataXX] = useState([
    {
      id: 'g1',
      type: 'group',
      name: 'Electronics',
      expanded: true,
      products: [
        {
          id: 'p1',
          type: 'product',
          name: 'Laptops',
          expanded: true,
          vendors: [
            {
              id: 'v1',
              type: 'vendor',
              name: 'Acme Corp',
              email: 'contact@acmecorp.com',
              phone: '+1 (555) 123-4567',
              contactPerson: 'John Smith',
              address: '123 Business Ave, NY',
              contractStart: '2024-01-15',
              contractEnd: '2025-01-15',
              status: 'Active',
              lastMessage: 'Payment processed'
            },
            {
              id: 'v2',
              type: 'vendor',
              name: 'TechSupply Inc',
              email: 'info@techsupply.com',
              phone: '+1 (555) 987-6543',
              contactPerson: 'Sarah Johnson',
              address: '456 Tech Park, SF',
              contractStart: '2023-06-01',
              contractEnd: '2024-12-31',
              status: 'Active',
              lastMessage: 'Delivery scheduled'
            }
          ]
        },
        {
          id: 'p2',
          type: 'product',
          name: 'Monitors',
          expanded: false,
          vendors: [
            {
              id: 'v3',
              type: 'vendor',
              name: 'Display Masters',
              email: 'sales@displaymasters.com',
              phone: '+1 (555) 456-7890',
              contactPerson: 'Mike Chen',
              address: '789 Screen Blvd, LA',
              contractStart: '2024-02-01',
              contractEnd: '2025-02-01',
              status: 'Pending',
              lastMessage: 'Quote requested'
            }
          ]
        }
      ]
    },
    {
      id: 'g2',
      type: 'group',
      name: 'Office Supplies',
      expanded: false,
      products: [
        {
          id: 'p3',
          type: 'product',
          name: 'Paper Products',
          expanded: false,
          vendors: []
        }
      ]
    }
  ]);

  const [messages, setMessages] = useState({
    v1: [
      { id: 1, type: 'event', text: 'Vendor onboarded', timestamp: new Date().toISOString(), user: 'System' },
      { id: 2, type: 'message', text: 'Payment processed successfully', timestamp: new Date().toISOString(), user: 'You' }
    ],
    v2: [
      { id: 1, type: 'event', text: 'Vendor onboarded', timestamp: new Date().toISOString(), user: 'System' },
      { id: 2, type: 'log', text: 'Delivery scheduled for next week', timestamp: new Date().toISOString(), user: 'You' }
    ],
    v3: [
      { id: 1, type: 'event', text: 'Vendor onboarded', timestamp: new Date().toISOString(), user: 'System' }
    ]
  });

  const [selectedItem, setSelectedItem] = useState('dashboard');
  const [searchTerm, setSearchTerm] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const [editFormData, setEditFormData] = useState({});
  const [newMessage, setNewMessage] = useState('');
  const [showAddDialog, setShowAddDialog] = useState(false);
  const [addItemType, setAddItemType] = useState(''); // 'group', 'product', 'vendor'
  const [parentItem, setParentItem] = useState(null);
  const [newItemName, setNewItemName] = useState('');
  const messagesEndRef = useRef(null);
  const [showProfile, setShowProfile] = useState(false);
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages, selectedItem]);

  const toggleExpand = (path) => {
    const newData = [...treeData];
    let current = newData;

    path.forEach((index, i) => {
      if (i === path.length - 1) {
        current[index].expanded = !current[index].expanded;
      } else {
        current = current[index].products || current[index].vendors;
      }
    });

    setTreeData(newData);
  };
  /*
    const handleSelect = (item) => {
  
      setSelectedItem(item);
      setIsEditing(false);
      if (item.m_type === 'vendor') {
        setEditFormData({
          m_email: item.m_email || '',
          m_phone: item.m_phone || '',
          m_contact_person: item.m_contact_person || '',
          m_address: item.m_address || '',
          m_contract_start: item.m_contract_start || '',
          m_contract_end: item.m_contract_end || '',
          m_status: item.m_status || 'Active'
        });
      }
    };
  */

  const handleEditChange = (field, value) => {
    setEditFormData(prev => ({ ...prev, [field]: value }));
  };
      const findProductId = (items) => {
        for (const item of items) {
          if (item.products) {
            for (const product of item.products) {
              if (product.vendors) {
                const vendor = product.vendors.find(v => v.m_id === selectedItem.m_id);
                if (vendor) return product.m_id;
              }
            }
          }
        }
        return null;
      };
  const handleSaveEdit = async () => {
    try {
      // Find the vendor's product ID from tree


      const productId = findProductId(treeData);
console.log("productId="+productId);
      await treeDataService.updateVendor(selectedItem.m_id, {
        ...editFormData,
        productId: productId,
        m_name: selectedItem.m_name
      });

      await loadTreeData(); // Reload entire tree
      setSelectedItem({ ...selectedItem, ...editFormData });
      setIsEditing(false);
    } catch (error) {
      console.error('Error updating vendor:', error);
      alert('Failed to update vendor information. Please try again.');
    }
  };


  const handleSaveEdit__ = () => {
    const updateVendorInTree = (items) => {
      return items.map(item => {
        if (item.m_type === 'vendor' && item.m_id === selectedItem.m_id) {
          return { ...item, ...editFormData };
        }
        if (item.products) {
          return { ...item, products: updateVendorInTree(item.products) };
        }
        if (item.vendors) {
          return { ...item, vendors: updateVendorInTree(item.vendors) };
        }
        return item;
      });
    };

    setTreeData(updateVendorInTree(treeData));
    setSelectedItem({ ...selectedItem, ...editFormData });
    setIsEditing(false);
  };
  /*
    const handleSendMessage = () => {
      if (!newMessage.trim() || !selectedItem || selectedItem.m_type !== 'vendor') return;
  
      const message = {
        id: Date.now(),
        type: 'message',
        text: newMessage,
        timestamp: new Date().toISOString(),
        user: 'You'
      };
  
      setMessages(prev => ({
        ...prev,
        [selectedItem.m_id]: [...(prev[selectedItem.m_id] || []), message]
      }));
  
      setNewMessage('');
    };
  */
  const loadVendorMessages = async (vendorId) => {
    console.log("loadVendorMessages>>>" + vendorId);
    try {
      const msgs = await treeDataService.getVendorMessages(vendorId);
      console.log(msgs);
      setMessages(prev => ({ ...prev, [vendorId]: msgs }));
    } catch (error) {
      console.error('Error loading messages:', error);
      // Set empty array if error
      setMessages(prev => ({ ...prev, [vendorId]: [] }));
    }
  };

  const handleSendMessage = async () => {
    if (!newMessage.trim() || !selectedItem || selectedItem.m_type !== 'vendor') return;
    console.log(newMessage)
    try {
      await treeDataService.createMessage(selectedItem.m_id, {
        m_type: 'message',
        m_text: newMessage,
        user: user?.m_username
      });

      // Reload messages for this vendor
      await loadVendorMessages(selectedItem.m_id);
      setNewMessage('');
    } catch (error) {
      console.error('Error sending message:', error);
      alert('Failed to send message. Please try again.');
    }
  };

  const [showLogEventDialog, setShowLogEventDialog] = useState(false);
  const [logEventType, setLogEventType] = useState('');
  const [logEventText, setLogEventText] = useState('');
  const [showRenameDialog, setShowRenameDialog] = useState(false);
  const [renameItem, setRenameItem] = useState(null);
  const [renameName, setRenameName] = useState('');
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [deleteItem, setDeleteItem] = useState(null);



  const openLogEventDialog = (type) => {
    if (!selectedItem || selectedItem.m_type !== 'vendor') return;
    setLogEventType(type);
    setLogEventText('');
    setShowLogEventDialog(true);
  };

  const handleLogEventKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleAddLogEvent();
    }
  };

  const openRenameDialog = (item) => {
    console.log(item)
    setRenameItem(item);
    setRenameName(item.m_name);
    setShowRenameDialog(true);
  };

  const handleRename = async () => {
    if (!renameName.trim()) return;

    try {
      if (renameItem.m_type === 'group') {
        await treeDataService.updateGroup(renameItem.m_id, renameName);
      } else if (renameItem.m_type === 'product') {
        await treeDataService.updateProduct(renameItem.m_id, renameName, renameItem.groupId);
      } else if (renameItem.m_type === 'vendor') {
        // Get current vendor data and update only the name
        const productId = findProductId(treeData);

      await treeDataService.updateVendor(selectedItem.m_id, {
        ...editFormData,
        productId: productId,
        m_name: renameName
      });


        //const vendorData = { ...renameItem, m_name: renameName };
        //console.log(vendorData)
        //await treeDataService.updateVendor(renameItem.m_id, vendorData);
      }

      await loadTreeData(); // Reload entire tree 

      if (selectedItem?.m_id === renameItem.m_id) {
        setSelectedItem({ ...selectedItem, name: renameName });
      }

      setShowRenameDialog(false);
      setRenameName('');
    } catch (error) {
      console.error('Error renaming item:', error);
      alert('Failed to rename item. Please try again.');
    }
  };

  const handleRename__ = () => {
    if (!renameName.trim()) return;

    const renameInTree = (items) => {
      return items.map(item => {
        if (item.m_id === renameItem.m_id && item.m_type === renameItem.m_type) {
          return { ...item, m_name: renameName };
        }
        if (item.products) {
          return { ...item, products: renameInTree(item.products) };
        }
        if (item.vendors) {
          return { ...item, vendors: renameInTree(item.vendors) };
        }
        return item;
      });
    };

    setTreeData(renameInTree(treeData));

    if (selectedItem?.m_id === renameItem.m_id) {
      setSelectedItem({ ...selectedItem, name: renameName });
    }

    setShowRenameDialog(false);
    setRenameName('');
  };

  const handleRenameKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleRename();
    }
  };


  const openDeleteDialog = (item, e) => {
    if (e) {
      e.stopPropagation();
    }
    setDeleteItem(item);
    setShowDeleteDialog(true);
  };

  const handleDelete = async () => {
    try {
      if (deleteItem.m_type === 'group') {
        await treeDataService.deleteGroup(deleteItem.m_id);
      } else if (deleteItem.m_type === 'product') {
        await treeDataService.deleteProduct(deleteItem.m_id);
      } else if (deleteItem.m_type === 'vendor') {
        await treeDataService.deleteVendor(deleteItem.m_id);
      }

      await loadTreeData(); // Reload entire tree

      if (selectedItem?.m_id === deleteItem.m_id) {
        setSelectedItem(null);
      }

      setShowDeleteDialog(false);
      setDeleteItem(null);
    } catch (error) {
      console.error('Error deleting item:', error);
      alert('Failed to delete item. Please try again.');
    }
  };

  const handleDelete__ = () => {
    const deleteFromTree = (items) => {
      return items
        .filter(item => !(item.m_id === deleteItem.m_id && item.m_type === deleteItem.m_type))
        .map(item => {
          if (item.products) {
            return { ...item, products: deleteFromTree(item.products) };
          }
          if (item.vendors) {
            return { ...item, vendors: deleteFromTree(item.vendors) };
          }
          return item;
        });
    };

    setTreeData(deleteFromTree(treeData));

    if (selectedItem?.m_id === deleteItem.m_id) {
      setSelectedItem(null);
    }

    setShowDeleteDialog(false);
    setDeleteItem(null);
  };



  const getDashboardStats = () => {
    let totalProducts = 0;
    let totalVendors = 0;
    let activeVendors = 0;
    let inactiveVendors = 0;
    let pendingVendors = 0;
    let expiringContracts = 0;

    const today = new Date();
    const thirtyDaysLater = new Date(today.getTime() + 30 * 24 * 60 * 60 * 1000);

    const countItems = (items) => {
      items.forEach(item => {
        if (item.m_type === 'group' && item.products) {
          totalProducts += item.products.length;
          item.products.forEach(product => {
            if (product.vendors) {
              totalVendors += product.vendors.length;
              product.vendors.forEach(vendor => {
                if (vendor.m_status === 'Active') activeVendors++;
                else if (vendor.m_status === 'Inactive') inactiveVendors++;
                else if (vendor.m_status === 'Pending') pendingVendors++;

                if (vendor.contractEnd) {
                  const endDate = new Date(vendor.m_contract_end);
                  if (endDate >= today && endDate <= thirtyDaysLater) {
                    expiringContracts++;
                  }
                }
              });
            }
          });
        }
      });
    };

    countItems(treeData);

    return {
      totalGroups: treeData.length,
      totalProducts,
      totalVendors,
      activeVendors,
      inactiveVendors,
      pendingVendors,
      expiringContracts
    };
  };





  const openAddDialog = (type, parent = null) => {
    setAddItemType(type);
    setParentItem(parent);
    setNewItemName('');
    setShowAddDialog(true);
  };
  const handleAddItem = async () => {
    if (!newItemName.trim()) return;

    try {
      if (addItemType === 'group') {
        const profile = getProfile();
        await treeDataService.createGroup(newItemName, profile);
        await loadTreeData(); // Reload entire tree
      } else if (addItemType === 'product') {
        await treeDataService.createProduct(parentItem.m_id, newItemName);
        await loadTreeData(); // Reload entire tree
      } else if (addItemType === 'vendor') {
        await treeDataService.createVendor(parentItem.m_id, { m_name: newItemName });
        await loadTreeData(); // Reload entire tree
      }

      setShowAddDialog(false);
      setNewItemName('');
    } catch (error) {
      console.error('Error adding item:', error);
      alert('Failed to add item. Please try again.');
    }
  };

  const handleAddItem__ = () => {
    if (!newItemName.trim()) return;

    const newData = [...treeData];

    if (addItemType === 'group') {
      // Add new group at root level
      const newGroup = {
        id: 'g' + Date.now(),
        type: 'group',
        name: newItemName,
        expanded: true,
        products: []
      };
      newData.push(newGroup);
      setTreeData(newData);
    } else if (addItemType === 'product') {
      // Add product to selected group
      const addProductToGroup = (items) => {
        return items.map(item => {
          if (item.m_type === 'group' && item.m_id === parentItem.m_id) {
            return {
              ...item,
              products: [
                ...(item.products || []),
                {
                  m_id: 'p' + Date.now(),
                  m_type: 'product',
                  m_name: newItemName,
                  expanded: true,
                  vendors: []
                }
              ]
            };
          }
          if (item.products) {
            return { ...item, products: addProductToGroup(item.products) };
          }
          return item;
        });
      };
      setTreeData(addProductToGroup(newData));
    } else if (addItemType === 'vendor') {
      // Add vendor to selected product
      const addVendorToProduct = (items) => {
        return items.map(item => {
          if (item.m_type === 'product' && item.m_id === parentItem.m_id) {
            const newVendor = {
              m_id: 'v' + Date.now(),
              m_type: 'vendor',
              m_name: newItemName,
              m_email: '',
              m_phone: '',
              m_contact_person: '',
              m_address: '',
              m_contract_start: '',
              m_contract_end: '',
              m_status: 'Pending',
              m_last_message: 'New vendor'
            };
            return {
              ...item,
              vendors: [...(item.vendors || []), newVendor]
            };
          }
          if (item.products) {
            return { ...item, products: addVendorToProduct(item.products) };
          }
          if (item.vendors) {
            return { ...item, vendors: addVendorToProduct(item.vendors) };
          }
          return item;
        });
      };
      setTreeData(addVendorToProduct(newData));
    }

    setShowAddDialog(false);
    setNewItemName('');
  };

  const formatTime = (timestamp) => {

    const date = new Date(timestamp);
    //return date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
    return date.toLocaleString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    }).replace(',', '').toUpperCase();

  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  const handleAddDialogKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAddItem();
    }
  };

  const renderTree = (items, path = []) => {
    return items.map((item, index) => {
      const currentPath = [...path, index];
      const hasChildren = (item.products?.length > 0) || (item.vendors?.length > 0);
      const isSelected = selectedItem?.m_id === item.m_id;

      return (
        <div key={item.m_id}>
          <div
            onClick={() => handleSelect(item)}
            style={{
              padding: '10px 12px 10px ' + (path.length * 20 + 12) + 'px',
              cursor: 'pointer',
              backgroundColor: isSelected ? '#eff6ff' : 'transparent',
              borderLeft: isSelected ? '3px solid #3b82f6' : '3px solid transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              transition: 'all 0.2s'
            }}
            onMouseEnter={(e) => !isSelected && (e.currentTarget.style.backgroundColor = '#f9fafb')}
            onMouseLeave={(e) => !isSelected && (e.currentTarget.style.backgroundColor = 'transparent')}
          >
            {hasChildren && (
              <div onClick={(e) => { e.stopPropagation(); toggleExpand(currentPath); }} style={{ cursor: 'pointer' }}>
                {item.expanded ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
              </div>
            )}
            {!hasChildren && <div style={{ width: '16px' }} />}

            {item.m_type === 'group' && (item.expanded ? <FolderOpen size={18} color="#f59e0b" /> : <Folder size={18} color="#f59e0b" />)}
            {item.m_type === 'product' && <Package size={18} color="#8b5cf6" />}
            {item.m_type === 'vendor' && <Building size={18} color="#3b82f6" />}

            <span style={{ fontSize: '14px', fontWeight: item.m_type === 'group' ? '600' : '500', color: '#111827', flex: 1 }}>
              {item.m_name}
            </span>

            {item.m_type === 'vendor' && item.m_status && (
              <span style={{
                padding: '2px 8px',
                borderRadius: '12px',
                fontSize: '11px',
                fontWeight: '600',
                backgroundColor: item.m_status === 'Active' ? '#d1fae5' : item.m_status === 'Pending' ? '#fef3c7' : '#fee2e2',
                color: item.m_status === 'Active' ? '#065f46' : item.m_status === 'Pending' ? '#92400e' : '#991b1b'
              }}>
                {item.m_status}
              </span>
            )}
          </div>

          {hasChildren && item.expanded && (
            <div>
              {item.products && renderTree(item.products, currentPath)}
              {item.vendors && renderTree(item.vendors, currentPath)}
            </div>
          )}
        </div>
      );
    });
  };
  // Update handleVendorSelect
  const handleSelect = async (item) => {
    //if(item.m_id===undefined)return;
    setSelectedItem(item);
    setIsEditing(false);

    if (item.m_type === 'vendor') {
      // Load messages from API
      //if (!messages[item.m_id]) {// enable this if second click should refresh again ornogt
      loadVendorMessages(item.m_id);
      //}
      const numericId = parseInt(item.m_id.replace('v', ''));
      try {
        const res = await api.get(`/Vendors/${numericId}`);
        //setData(res);
        console.log(res);
        const dat={
          m_email: res.m_email || 'xxx',
          m_phone: res.m_phone || '',
          m_contact_person: res.m_contact_person || '',
          m_email2: res.m_email2 || 'xxx',
          m_phone2: res.m_phone2 || '',
          m_contact_person2: res.m_contact_person2 || '',          
          m_company: res.m_company || '',
          m_address: res.m_address || '',
          m_contract_start: res.m_contract_start || '',
          m_contract_end: res.m_contract_end || '',
          m_status: res.m_status || 'Active'
        };
        console.log(dat);
        setEditFormData(dat);

      } catch (err) {
        console.error(err);
      } finally {
        //setLoading(false);
      }






    }
  };
  /*
  const handleAddLogEvent = () => {
    if (!logEventText.trim()) return;

    const entry = {
      id: Date.now(),
      type: logEventType,
      text: logEventText,
      timestamp: new Date().toISOString(),
      user: 'You'
    };

    setMessages(prev => ({
      ...prev,
      [selectedItem.m_id]: [...(prev[selectedItem.m_id] || []), entry]
    }));

    setShowLogEventDialog(false);
    setLogEventText('');
  };
  */

  const handleAddLogEvent = async () => {
    if (!logEventText.trim()) return;

    try {
      await treeDataService.createMessage(selectedItem.m_id, {
        type: logEventType,
        text: logEventText,
        user: user?.m_username
      });

      // Reload messages for this vendor
      await loadVendorMessages(selectedItem.m_id);
      setShowLogEventDialog(false);
      setLogEventText('');
    } catch (error) {
      console.error('Error adding log/event:', error);
      alert('Failed to add log/event. Please try again.');
    }
  };

  const renderDetailPanel = () => {
    if (!selectedItem) {
      return (
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: '#9ca3af' }}>
          <Building size={64} style={{ marginBottom: '16px', color: '#d1d5db' }} />
          <p style={{ fontSize: '18px', fontWeight: '500' }}>Select an item from the tree</p>
        </div>
      );
    }

    if (selectedItem === 'dashboard') {
      const stats = getDashboardStats();
      return (
        <div style={{ flex: 1, padding: '40px', overflowY: 'auto', backgroundColor: '#f9fafb' }}>

          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',  // ✅ pushes ends apart
              alignItems: 'center',             // ✅ vertical alignment
              marginBottom: '24px'
            }}
          >
            <h2
              style={{
                fontSize: '28px',
                fontWeight: '700',
                color: '#111827',
                margin: 0                      // ✅ remove default margin
              }}
            >
              Dashboard Overview
            </h2>

            <div style={{ fontWeight: '600', color: '#374151' }}>
              {activeProfile}
            </div>
          </div>






          {/* Summary Cards */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px', marginBottom: '32px' }}>
            <div style={{ backgroundColor: 'white', padding: '24px', borderRadius: '12px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', border: '1px solid #e5e7eb' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
                <div style={{ width: '48px', height: '48px', borderRadius: '12px', backgroundColor: '#fef3c7', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <FolderOpen size={24} color="#f59e0b" />
                </div>
                <div>
                  <p style={{ fontSize: '13px', color: '#6b7280', margin: 0 }}>Total Groups</p>
                  <p style={{ fontSize: '32px', fontWeight: '700', color: '#111827', margin: 0 }}>{stats.totalGroups}</p>
                </div>
              </div>
            </div>

            <div style={{ backgroundColor: 'white', padding: '24px', borderRadius: '12px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', border: '1px solid #e5e7eb' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
                <div style={{ width: '48px', height: '48px', borderRadius: '12px', backgroundColor: '#e9d5ff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <Package size={24} color="#8b5cf6" />
                </div>
                <div>
                  <p style={{ fontSize: '13px', color: '#6b7280', margin: 0 }}>Total Products</p>
                  <p style={{ fontSize: '32px', fontWeight: '700', color: '#111827', margin: 0 }}>{stats.totalProducts}</p>
                </div>
              </div>
            </div>

            <div style={{ backgroundColor: 'white', padding: '24px', borderRadius: '12px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', border: '1px solid #e5e7eb' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
                <div style={{ width: '48px', height: '48px', borderRadius: '12px', backgroundColor: '#dbeafe', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <Building size={24} color="#3b82f6" />
                </div>
                <div>
                  <p style={{ fontSize: '13px', color: '#6b7280', margin: 0 }}>Total Vendors</p>
                  <p style={{ fontSize: '32px', fontWeight: '700', color: '#111827', margin: 0 }}>{stats.totalVendors}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Vendor Status Breakdown */}
          <div style={{ backgroundColor: 'white', padding: '24px', borderRadius: '12px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', border: '1px solid #e5e7eb', marginBottom: '32px' }}>
            <h3 style={{ fontSize: '18px', fontWeight: '600', color: '#111827', marginBottom: '20px' }}>Vendor Status</h3>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '16px' }}>
              <div style={{ textAlign: 'center', padding: '16px', backgroundColor: '#d1fae5', borderRadius: '8px' }}>
                <p style={{ fontSize: '28px', fontWeight: '700', color: '#065f46', margin: '0 0 4px 0' }}>{stats.activeVendors}</p>
                <p style={{ fontSize: '13px', color: '#065f46', margin: 0 }}>Active</p>
              </div>
              <div style={{ textAlign: 'center', padding: '16px', backgroundColor: '#fef3c7', borderRadius: '8px' }}>
                <p style={{ fontSize: '28px', fontWeight: '700', color: '#92400e', margin: '0 0 4px 0' }}>{stats.pendingVendors}</p>
                <p style={{ fontSize: '13px', color: '#92400e', margin: 0 }}>Pending</p>
              </div>
              <div style={{ textAlign: 'center', padding: '16px', backgroundColor: '#fee2e2', borderRadius: '8px' }}>
                <p style={{ fontSize: '28px', fontWeight: '700', color: '#991b1b', margin: '0 0 4px 0' }}>{stats.inactiveVendors}</p>
                <p style={{ fontSize: '13px', color: '#991b1b', margin: 0 }}>Inactive</p>
              </div>
            </div>
          </div>

          {/* Contract Expiration Alert */}
          {stats.expiringContracts > 0 && (
            <div style={{ backgroundColor: '#fef3c7', padding: '20px', borderRadius: '12px', border: '2px solid #f59e0b', marginBottom: '32px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div style={{ fontSize: '32px' }}>⚠️</div>
                <div>
                  <h3 style={{ fontSize: '16px', fontWeight: '700', color: '#92400e', margin: '0 0 4px 0' }}>
                    {stats.expiringContracts} Contract{stats.expiringContracts > 1 ? 's' : ''} Expiring Soon
                  </h3>
                  <p style={{ fontSize: '14px', color: '#92400e', margin: 0 }}>
                    {stats.expiringContracts} vendor contract{stats.expiringContracts > 1 ? 's' : ''} will expire within the next 30 days
                  </p>
                </div>
              </div>
            </div>
          )}

          {/* Quick Stats */}
          <div style={{ backgroundColor: 'white', padding: '24px', borderRadius: '12px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', border: '1px solid #e5e7eb' }}>
            <h3 style={{ fontSize: '18px', fontWeight: '600', color: '#111827', marginBottom: '16px' }}>Quick Stats</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '12px', backgroundColor: '#f9fafb', borderRadius: '8px' }}>
                <span style={{ fontSize: '14px', color: '#6b7280' }}>Average Vendors per Product</span>
                <span style={{ fontSize: '14px', fontWeight: '600', color: '#111827' }}>
                  {stats.totalProducts > 0 ? (stats.totalVendors / stats.totalProducts).toFixed(1) : '0'}
                </span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '12px', backgroundColor: '#f9fafb', borderRadius: '8px' }}>
                <span style={{ fontSize: '14px', color: '#6b7280' }}>Active Vendor Rate</span>
                <span style={{ fontSize: '14px', fontWeight: '600', color: '#111827' }}>
                  {stats.totalVendors > 0 ? ((stats.activeVendors / stats.totalVendors) * 100).toFixed(0) : '0'}%
                </span>
              </div>
            </div>
          </div>
        </div>
      );
    }

    if (selectedItem.m_type === 'group') {
      return (
        <div style={{ flex: 1, padding: '40px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
            <FolderOpen size={32} color="#f59e0b" />
            <div style={{ flex: 1 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#111827', margin: 0 }}>Group: {selectedItem.m_name}</h2>
                {user?.m_role === "Admin" && (
                  <div style={{ display: 'flex', gap: '8px' }}>
                    <button
                      onClick={() => openRenameDialog(selectedItem)}
                      style={{ padding: '4px 8px', backgroundColor: '#f3f4f6', color: '#6b7280', border: 'none', borderRadius: '6px', fontSize: '12px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px' }}
                      title="Rename group"
                    >
                      <Edit2 size={14} /> Rename
                    </button>
                    <button
                      onClick={(e) => openDeleteDialog(selectedItem, e)}
                      style={{ padding: '4px 8px', backgroundColor: '#fee2e2', color: '#991b1b', border: 'none', borderRadius: '6px', fontSize: '12px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px' }}
                      title="Delete group"
                    >
                      <X size={14} /> Delete
                    </button>
                  </div>
                )}
              </div>
              <p style={{ color: '#6b7280', margin: '4px 0 0 0' }}>{selectedItem.products?.length || 0} products</p>
            </div>
            <button
              onClick={() => openAddDialog('product', selectedItem)}
              style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 16px', backgroundColor: '#8b5cf6', color: 'white', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '600', cursor: 'pointer' }}
            >
              <Plus size={18} /> Add Product
            </button>
          </div>
          <div style={{ padding: '20px', backgroundColor: '#f9fafb', borderRadius: '8px', border: '1px solid #e5e7eb' }}>
            <p style={{ fontSize: '14px', color: '#6b7280' }}>This is a product group. Click "Add Product" to add new products to this group.</p>
          </div>
        </div>
      );
    }

    if (selectedItem.m_type === 'product') {
      return (
        <div style={{ flex: 1, padding: '40px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
            <Package size={32} color="#8b5cf6" />
            <div style={{ flex: 1 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#111827', margin: 0 }}>Product: {selectedItem.m_name}</h2>

                {user?.m_role === "Admin" && (
                  <div style={{ display: 'flex', gap: '8px' }}>

                    <button
                      onClick={() => openRenameDialog(selectedItem)}
                      style={{ padding: '4px 8px', backgroundColor: '#f3f4f6', color: '#6b7280', border: 'none', borderRadius: '6px', fontSize: '12px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px' }}
                      title="Rename product"
                    >
                      <Edit2 size={14} /> Rename
                    </button>


                    <button
                      onClick={(e) => openDeleteDialog(selectedItem, e)}
                      style={{ padding: '4px 8px', backgroundColor: '#fee2e2', color: '#991b1b', border: 'none', borderRadius: '6px', fontSize: '12px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px' }}
                      title="Delete product"
                    >
                      <X size={14} /> Delete
                    </button>
                  </div>)}

              </div>
              <p style={{ color: '#6b7280', margin: '4px 0 0 0' }}>{selectedItem.vendors?.length || 0} vendors</p>
            </div>
            <button
              onClick={() => openAddDialog('vendor', selectedItem)}
              style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 16px', backgroundColor: '#3b82f6', color: 'white', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '600', cursor: 'pointer' }}
            >
              <Plus size={18} /> Add Vendor
            </button>
          </div>
          <div style={{ padding: '20px', backgroundColor: '#f9fafb', borderRadius: '8px', border: '1px solid #e5e7eb' }}>
            <p style={{ fontSize: '14px', color: '#6b7280' }}>This product has {selectedItem.vendors?.length || 0} vendors. Click "Add Vendor" to add a new vendor to this product.</p>
          </div>
        </div>
      );
    }

    // Vendor details with messages
    const vendorMessages = messages[selectedItem.m_id] || [];











    return (
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', backgroundColor: '#f9fafb' }}>
        {/* Vendor Header */}
        <div style={{ padding: '16px 20px', backgroundColor: 'white', borderBottom: '1px solid #e5e7eb' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px' }}>
            <h2 style={{ fontSize: '20px', fontWeight: '700', color: '#111827', margin: 0 }}>{selectedItem.m_name}</h2>
            {user?.m_role === "Admin" && (
              <div style={{ display: 'flex', gap: '8px' }}>
                <button
                  onClick={() => openRenameDialog(selectedItem)}
                  style={{ padding: '4px 8px', backgroundColor: '#f3f4f6', color: '#6b7280', border: 'none', borderRadius: '6px', fontSize: '12px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px' }}
                  title="Rename vendor"
                >
                  <Edit2 size={14} /> Rename
                </button>

                <button
                  onClick={(e) => openDeleteDialog(selectedItem, e)}
                  style={{ padding: '4px 8px', backgroundColor: '#fee2e2', color: '#991b1b', border: 'none', borderRadius: '6px', fontSize: '12px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px' }}
                  title="Delete vendor"
                >
                  <X size={14} /> Delete
                </button>
              </div>)}

          </div>
          <div style={{ display: 'flex', gap: '12px' }}>
            <button
              onClick={() => openLogEventDialog('log')}
              style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '8px 14px', backgroundColor: '#d1fae5', color: '#065f46', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}
            >
              <MessageSquare style={{ width: '16px', height: '16px' }} />
              Add Log
            </button>
            <button
              onClick={() => openLogEventDialog('event')}
              style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '8px 14px', backgroundColor: '#e9d5ff', color: '#6b21a8', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}
            >
              <Tag style={{ width: '16px', height: '16px' }} />
              Add Event
            </button>
            <button
              onClick={() => {
                setShowProfile(prev => {
                  if (prev) setIsEditing(false);
                  return !prev;
                });
              }}
              style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '8px 14px', backgroundColor: 'lightblue', color: '#6b21a8', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}
            >
              {showProfile ? <ChevronsUp size={16} /> : <ChevronsDown size={16} />}
              {showProfile ? "Hide Profile" : "Show Profile"}
            </button>
          </div>
        </div>

        {/* Vendor Information Panel */}
        {showProfile && (
          <div style={{ padding: '20px', backgroundColor: '#dd33', borderBottom: '1px solid #e5e7eb', borderRadius: '20px', margin: '4px', border: '1px solid lightgrey', paddingRight: '8px',maxWidth:'900px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
              <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#111827', margin: 0 }}>Vendor Information</h3>
              {!isEditing ? (
                <button onClick={() => setIsEditing(true)} style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '6px 12px', backgroundColor: '#3b82f6', color: 'white', border: 'none', borderRadius: '6px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}>
                  <Edit2 size={16} /> Edit
                </button>
              ) : (
                <div style={{ display: 'flex', gap: '8px' }}>
                  <button onClick={handleSaveEdit} style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '6px 12px', backgroundColor: '#10b981', color: 'white', border: 'none', borderRadius: '6px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}>
                    <Save size={16} /> Save
                  </button>
                  <button onClick={() => setIsEditing(false)} style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '6px 12px', backgroundColor: '#ef4444', color: 'white', border: 'none', borderRadius: '6px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}>
                    <X size={16} /> Cancel
                  </button>
                </div>
              )}
            </div>
{/*gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))'*/}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '8px' }}>


              <InfoField icon={<Mail size={16} />} label="Email" value={editFormData.m_email} isEditing={isEditing} onChange={(v) => handleEditChange('m_email', v)} type="email" />
              <InfoField icon={<Phone size={16} />} label="Phone" value={editFormData.m_phone} isEditing={isEditing} onChange={(v) => handleEditChange('m_phone', v)} type="tel" />
              <InfoField icon={<Building size={16} />} label="Contact Person" value={editFormData.m_contact_person} isEditing={isEditing} onChange={(v) => handleEditChange('m_contact_person', v)} />

              <InfoField1 icon={<Mail size={16} />} label="Email" value={editFormData.m_email2} isEditing={isEditing} onChange={(v) => handleEditChange('m_email2', v)} type="email"/>
              <InfoField1 icon={<Phone size={16} />} label="Phone" value={editFormData.m_phone2} isEditing={isEditing} onChange={(v) => handleEditChange('m_phone2', v)} type="tel" />
              <InfoField1 icon={<Building size={16} />} label="Contact Person" value={editFormData.m_contact_person2} isEditing={isEditing} onChange={(v) => handleEditChange('m_contact_person2', v)} />



              <div style={{ gridColumn: '1 / -1' }}>
                <InfoField2 icon={<MapPin size={16} />} label="Address" value={editFormData.m_address} isEditing={isEditing} onChange={(v) => handleEditChange('m_address', v)}/>
              </div>
              <InfoField icon={<Calendar size={16} />} label="Contract Start" value={editFormData.m_contract_start} isEditing={isEditing} onChange={(v) => handleEditChange('m_contract_start', v)} type="date" />
              <InfoField icon={<Calendar size={16} />} label="Contract End" value={editFormData.m_contract_end} isEditing={isEditing} onChange={(v) => handleEditChange('m_contract_end', v)} type="date" />
              <div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', fontWeight: '600', color: '#6b7280', marginBottom: '8px' }}>
                  <span style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: editFormData.m_status === 'Active' ? '#10b981' : editFormData.m_status === 'Pending' ? '#f59e0b' : '#ef4444' }}></span>
                  <span>Status</span>
                </div>
                {isEditing ? (
                  <select value={editFormData.m_status} onChange={(e) => handleEditChange('m_status', e.target.value)} style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none' }}>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                    <option value="Pending">Pending</option>
                  </select>
                ) : (
                  <div style={{ padding: '10px 12px', backgroundColor: 'white', borderRadius: '6px', border: '1px solid #bbb',backgroundColor:'#eee' }}>
                    <span style={{ padding: '4px 12px', borderRadius: '6px', fontSize: '12px', fontWeight: '600', backgroundColor: editFormData.m_status === 'Active' ? '#d1fae5' : editFormData.m_status === 'Pending' ? '#fef3c7' : '#fee2e2', color: editFormData.m_status === 'Active' ? '#065f46' : editFormData.m_status === 'Pending' ? '#92400e' : '#991b1b' }}>
                      {editFormData.m_status}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        {/* Messages Section */}
        <div style={{ flex: 1, overflowY: 'auto', padding: '20px', backgroundColor: '#f9fafb' }}>
          {vendorMessages.map((msg) => (
            <div key={msg.m_id} style={{ marginBottom: '16px', display: 'flex', justifyContent: msg.m_user === user?.m_username ? 'flex-end' : 'flex-start' }}>
              <div style={{ maxWidth: '600px', padding: '12px 16px', borderRadius: '12px', backgroundColor: msg.m_type === 'event' ? '#e9d5ff' : msg.m_type === 'log' ? '#d1fae5' : msg.m_user === user?.m_username ? '#3b82f6' : 'turquoise', color: msg.m_user === user?.m_username && msg.m_type === 'message' ? 'white' : '#111827', borderLeft: msg.m_type !== 'message' ? `4px solid ${msg.m_type === 'event' ? '#a855f7' : '#10b981'}` : 'none', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>
                {msg.m_type !== 'message' && (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '6px', fontSize: '11px', fontWeight: '700' }}>
                    {msg.m_type === 'event' ? <Tag style={{ width: '16px', height: '16px' }} /> : <MessageSquare style={{ width: '16px', height: '16px' }} />}
                    <span>{msg.m_type?.toUpperCase()}</span>
                  </div>
                )}
                <p style={{ fontSize: '15px', lineHeight: '1.5', margin: 0 }}>{msg.m_text}</p>
                <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginTop: '6px', fontSize: '11px', opacity: 0.7 }}>
                  <Clock style={{ width: '12px', height: '12px' }} />
                  <div style={{ display: 'flex', gap: '30px', justifyContent: 'space-between', justifyContent: 'space-between', width: '100%' }}><div>{formatTime(msg.m_timestamp)}</div><div>{msg.m_user}</div></div>
                </div>
              </div>
            </div>
          ))}
          <div ref={messagesEndRef} />
        </div>

        <div style={{ display: 'flex', gap: '12px', padding: '16px 20px', backgroundColor: 'white', borderTop: '1px solid #e5e7eb' }}>
          <input
            type="text"
            value={newMessage}
            onChange={(e) => setNewMessage(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="Type a message..."
            style={{ flex: 1, padding: '12px 16px', border: '1px solid #d1d5db', borderRadius: '24px', fontSize: '15px', outline: 'none' }}
          />
          <button onClick={handleSendMessage} style={{ width: '48px', height: '48px', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#3b82f6', color: 'white', border: 'none', borderRadius: '50%', cursor: 'pointer' }}>
            <Send style={{ width: '20px', height: '20px' }} />
          </button>
        </div>
      </div>
    );
  };

  return (
    <div style={{ display: 'flex', height: '100vh', backgroundColor: '#f5f5f5', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}>
      <div style={{ width: '360px', backgroundColor: '#ffffff', borderRight: '1px solid #e5e7eb', display: 'flex', flexDirection: 'column' }}>
        <div style={{ padding: '20px', paddingBottom: '5px', borderBottom: '1px solid #e5e7eb' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginBottom: '16px' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div>
                <img src='SharewareDreamsLogo.png' style={{ height: '30px' }} />
                {/*<h1 style={{ fontSize: '24px', fontWeight: '700', color: '#111827', margin: 0 }}>Shareware Dreams</h1>*/}
                <p style={{ fontSize: '13px', color: '#6b7280', margin: '4px 0 0 0' }}>
                  Welcome, <strong>{user?.m_name || 'User'}</strong> ({user?.m_role || 'User'})
                </p>
              </div>
              <button
                onClick={onLogout}
                style={{ padding: '6px 12px', backgroundColor: '#fee2e2', color: '#991b1b', border: 'none', borderRadius: '6px', fontSize: '12px', fontWeight: '600', cursor: 'pointer' }}
              >
                Logout
              </button>

            </div>



            <div style={{ display: 'flex', gap: '10px' }}>

              <div style={{ flex: 1 }}>
                <ProfileDropdown user={user} activeProfile={activeProfile} setActiveProfile={setActiveProfile} />
              </div>

              <button
                onClick={() => setSelectedItem('dashboard')}
                style={{
                  flex: 1,
                  height: '38px',                 // ✅ fixed height
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  padding: '0 16px',              // ✅ remove vertical padding
                  backgroundColor: selectedItem === 'dashboard' ? '#3b82f6' : '#f3f4f6',
                  color: selectedItem === 'dashboard' ? 'white' : '#6b7280',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  marginTop: '10px'
                }}
              >
                <LayoutDashboard style={{ width: '18px', height: '18px' }} />
                Dashboard
              </button>

            </div>




          </div>

          <div style={{ position: 'relative', marginBottom: '12px' }}>
            <Search style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', width: '20px', height: '20px', color: '#9ca3af' }} />
            <input
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{ width: '100%', padding: '10px 12px 10px 40px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', outline: 'none' }}
            />
          </div>

        </div>
        {/*
        {activeProfile.length===0 && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',  // horizontal center
              alignItems: 'center',      // vertical center
              height: '30%',             // IMPORTANT (or fixed height)
              color:'#999'
            }}
          >
            Select a profile from the top Dropdown {activeProfile}
          </div>
        )}*/}
        <div style={{ flex: 1, overflowY: 'auto' }}>
          {renderTree(treeData)}
        </div>
        <div style={{ padding: '20px', borderTop: '1px solid #e5e7eb' }}>
          <button
            onClick={() => openAddDialog('group')}
            style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', padding: '10px 16px', backgroundColor: '#3b82f6', color: 'white', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '600', cursor: 'pointer' }}
          >
            <Plus style={{ width: '18px', height: '18px' }} />
            Add Group
          </button>
        </div>
      </div>

      {renderDetailPanel()}


      {/* Add Item Dialog */}
      {showAddDialog && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ backgroundColor: 'white', borderRadius: '12px', padding: '24px', width: '400px', boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)' }}>
            <h3 style={{ fontSize: '18px', fontWeight: '700', color: '#111827', marginBottom: '16px' }}>
              Add New {addItemType.charAt(0).toUpperCase() + addItemType.slice(1)}
            </h3>
            {parentItem && (
              <p style={{ fontSize: '14px', color: '#6b7280', marginBottom: '12px' }}>
                to: <strong>{parentItem.m_name}</strong>
              </p>
            )}
            <input
              type="text"
              placeholder={`Enter ${addItemType} name`}
              value={newItemName}
              onChange={(e) => setNewItemName(e.target.value)}
              onKeyPress={handleAddDialogKeyPress}
              autoFocus
              style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', marginBottom: '16px', outline: 'none' }}
            />
            <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
              <button
                onClick={() => setShowAddDialog(false)}
                style={{ padding: '10px 16px', backgroundColor: '#e5e7eb', color: '#374151', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '600', cursor: 'pointer' }}
              >
                Cancel
              </button>
              <button
                onClick={handleAddItem}
                style={{ padding: '10px 16px', backgroundColor: '#3b82f6', color: 'white', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '600', cursor: 'pointer' }}
              >
                Add {addItemType.charAt(0).toUpperCase() + addItemType.slice(1)}
              </button>
            </div>
          </div>
        </div>
      )}




      {/* Delete Confirmation Dialog */}
      {showDeleteDialog && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ backgroundColor: 'white', borderRadius: '12px', padding: '24px', width: '400px', boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)' }}>
            <h3 style={{ fontSize: '18px', fontWeight: '700', color: '#991b1b', marginBottom: '16px' }}>
              Delete {deleteItem?.m_type.charAt(0).toUpperCase() + deleteItem?.m_type.slice(1)}?
            </h3>
            <p style={{ fontSize: '14px', color: '#6b7280', marginBottom: '16px' }}>
              Are you sure you want to delete <strong>{deleteItem?.m_name}</strong>?
              {deleteItem?.m_type === 'group' && deleteItem?.products?.length > 0 &&
                ` This group has ${deleteItem.products.length} product(s) and will be permanently removed.`}
              {deleteItem?.m_type === 'product' && deleteItem?.vendors?.length > 0 &&
                ` This product has ${deleteItem.vendors.length} vendor(s) and will be permanently removed.`}
              {deleteItem?.m_type === 'vendor' &&
                ` All messages and vendor information will be permanently removed.`}
            </p>
            <p style={{ fontSize: '13px', color: '#ef4444', marginBottom: '16px', fontWeight: '600' }}>
              This action cannot be undone.
            </p>
            <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
              <button
                onClick={() => setShowDeleteDialog(false)}
                style={{ padding: '10px 16px', backgroundColor: '#e5e7eb', color: '#374151', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '600', cursor: 'pointer' }}
              >
                Cancel
              </button>
              <button
                onClick={handleDelete}
                style={{ padding: '10px 16px', backgroundColor: '#ef4444', color: 'white', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '600', cursor: 'pointer' }}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}



      {/* Rename Dialog */}
      {showRenameDialog && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          X{renameItem?.m_product_id}Y
          <div style={{ backgroundColor: 'white', borderRadius: '12px', padding: '24px', width: '400px', boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)' }}>
            <h3 style={{ fontSize: '18px', fontWeight: '700', color: '#111827', marginBottom: '16px' }}>
              Rename {renameItem?.m_type.charAt(0).toUpperCase() + renameItem?.m_type.slice(1)}
            </h3>
            <input
              type="text"
              placeholder="Enter new name"
              value={renameName}
              onChange={(e) => setRenameName(e.target.value)}
              onKeyPress={handleRenameKeyPress}
              autoFocus
              style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', marginBottom: '16px', outline: 'none' }}
            />
            <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
              <button
                onClick={() => setShowRenameDialog(false)}
                style={{ padding: '10px 16px', backgroundColor: '#e5e7eb', color: '#374151', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '600', cursor: 'pointer' }}
              >
                Cancel
              </button>
              <button
                onClick={handleRename}
                style={{ padding: '10px 16px', backgroundColor: '#3b82f6', color: 'white', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '600', cursor: 'pointer' }}
              >
                Rename
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Add Log/Event Dialog */}
      {showLogEventDialog && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ backgroundColor: 'white', borderRadius: '12px', padding: '24px', width: '500px', boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)' }}>
            <h3 style={{ fontSize: '18px', fontWeight: '700', color: '#111827', marginBottom: '16px' }}>
              Add {logEventType === 'log' ? 'Log Entry' : 'Event'}
            </h3>
            <p style={{ fontSize: '14px', color: '#6b7280', marginBottom: '12px' }}>
              {logEventType === 'log'
                ? 'Record an activity or action (e.g., "Payment received", "Delivery completed")'
                : 'Record a milestone or important event (e.g., "Contract signed", "Annual review scheduled")'}
            </p>
            <textarea
              placeholder={logEventType === 'log' ? 'Enter log details...' : 'Enter event details...'}
              value={logEventText}
              onChange={(e) => setLogEventText(e.target.value)}
              onKeyPress={handleLogEventKeyPress}
              autoFocus
              rows={3}
              style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', marginBottom: '16px', outline: 'none', resize: 'vertical', fontFamily: 'inherit' }}
            />
            <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
              <button
                onClick={() => setShowLogEventDialog(false)}
                style={{ padding: '10px 16px', backgroundColor: '#e5e7eb', color: '#374151', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '600', cursor: 'pointer' }}
              >
                Cancel
              </button>
              <button
                onClick={handleAddLogEvent}
                style={{ padding: '10px 16px', backgroundColor: logEventType === 'log' ? '#10b981' : '#a855f7', color: 'white', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '600', cursor: 'pointer' }}
              >
                Add {logEventType === 'log' ? 'Log' : 'Event'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const InfoField = ({ icon, label, value, isEditing, onChange, type = 'text' }) => (
  <div style={{maxWidth:'300px'}}>
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', fontWeight: '600', color: '#6b7280', marginBottom: '8px' }}>
      {icon}
      <span>{label}</span>
    </div>
    {isEditing ? (
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={{ width: '100%', backgroundColor: 'white',padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none' }}
      />
    ) : (
      <div style={{ padding: '10px 12px', backgroundColor: '#eee', borderRadius: '6px', border: '1px solid #bbb', fontSize: '14px', color: '#111827', minHeight: '40px', display: 'flex', alignItems: 'center' }}>
        {value || 'Not set'}
      </div>
    )}
  </div>
);
const InfoField2 = ({ icon, label, value, isEditing, onChange, type = 'text' }) => (
  <div>
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', fontWeight: '600', color: '#6b7280', marginBottom: '8px' }}>
      {icon}
      <span>{label}</span>
    </div>
    {isEditing ? (
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={{ width: '100%', backgroundColor: 'white',padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none' }}
      />
    ) : (
      <div style={{ padding: '10px 12px', backgroundColor: '#eee', borderRadius: '6px', border: '1px solid #bbb', fontSize: '14px', color: '#111827', minHeight: '40px', display: 'flex', alignItems: 'center' }}>
        {value || 'Not set'}
      </div>
    )}
  </div>
);
const InfoField1 = ({ icon, label, value, isEditing, onChange, type = 'text' }) => (
  <div style={{maxWidth:'300px'}}>
    {isEditing ? (
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={{ width: '100%',backgroundColor: 'white', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none' }}
      />
    ) : (
      <div style={{ padding: '10px 12px', backgroundColor: '#eee', borderRadius: '6px', border: '1px solid #bbb', fontSize: '14px', color: '#111827', minHeight: '40px', display: 'flex', alignItems: 'center' }}>
        {value || 'Not set'}
      </div>
    )}
  </div>
);

export default TreeArchitectureApp;


